// v4 wildcard 404 (VG1-gaps) — replaces @refinedev/antd's ErrorComponent,
// the last unnamed antd mount in the v4 shell graph (F3 bundle-proof
// prerequisite). Keeps the mistyped URL in the address bar (v1 parity).
// Refine's ErrorComponent = Result status="404": title "404" + subtitle +
// Back Home; the magnifier circle stands in for antd's 404 illustration.
import { MagniferLinear } from '@assessprep/icons/solar';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { APStatusView } from '@/components/ap/status/APStatusView';
import { Button } from '@/components/ui/button';

export const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <APStatusView
      className="min-h-[60vh]"
      tone="neutral"
      icon={<MagniferLinear />}
      title={<span className="tabular-nums">404</span>}
      description={t('V4Shell.sorry_the_page_you_visited_does_not_exist')}
      testId="v4-not-found"
      actions={
        <Button onClick={() => navigate('/')} data-testid="v4-not-found-home">
          {t('V4Shell.back_to_home')}
        </Button>
      }
    />
  );
};
